module.exports = __webpack_public_path__ + "static/media/icon_instrument_french_horn.1a58d8e7.svg";